import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: ${theme.tggSpacing(rem(45), 360)};
        padding: ${theme.tggSpacing(rem(3), 7.5)};
	`}
`;

export const StyledSmallTextContent = styled('p')`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(2), 5)};
        margin-bottom: ${theme.tggSpacing(0, 0)};
        font-size: small;
        color: ${theme.palette.common.blue};
        text-align: center;
	`}
`;

export const StyledHeading = styled('h2')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_19_bold_lh_22_desktop_26_lh_30}
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing(0, 0)};
        text-align: center;
	`}
`;
